import type {
  BackInStockProductGroup,
  BackInStockVariantDetail,
} from "@redotech/redo-customer-common/customer-product-notification/customer-product-notification";
import EmailIcon from "@redotech/redo-icons/mail-02.svg";
import { RedoEmptyState } from "@redotech/redo-web/arbiter-components/empty-state/redo-empty-state";
import { RedoTable } from "@redotech/redo-web/arbiter-components/tables/redo-table";
import { Divider } from "@redotech/redo-web/divider";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { VARIANT_TABLE_LAYOUT } from "./variant-columns";

export const VariantsTab = memo(function VariantsTab({
  product,
  onVariantClick,
}: {
  product: BackInStockProductGroup;
  onVariantClick: (variantId: string) => void;
}) {
  return (
    <Flex dir="column" flex={1} gap="none" overflow="hidden">
      <Flex dir="column" flex={1} gap="none" overflow="auto">
        <RedoTable<BackInStockVariantDetail>
          emptyStateContent={
            product.variants.length === 0 ? (
              <Flex align="center" flex={1} justify="center">
                <RedoEmptyState
                  Icon={EmailIcon}
                  subtext="No variant data available."
                  text="No variants"
                  useNonArbiterPadding
                />
              </Flex>
            ) : undefined
          }
          layout={VARIANT_TABLE_LAYOUT}
          onRowClick={(row) => onVariantClick(row.variantId)}
          rowsOfData={product.variants}
          size="sm"
        />
      </Flex>
      <Divider />
      <Flex align="center" justify="space-between" px="xl" py="md">
        <Text fontSize="sm" textColor="secondary">
          Showing {product.variants.length} of {product.variantCount}
        </Text>
      </Flex>
    </Flex>
  );
});
